import { useEffect, useState } from "react";
import Button from "../../shared/Button";
import PasswordInput from "../../shared/PasswordInput";
import styles from './LoginView.module.css';
import { authService } from "../../features/Auth/authService";
import DottedBg2 from "../../components/originkit/ui/chromatic-waves";

const LoginView = () =>
{
	const [password, setPassword] = useState<string>("");

	useEffect(() =>
	{
		if (sessionStorage.getItem("loginToken"))
		{
			window.location.href = "/mods";
		}
	}, []);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		setPassword(event.target.value);
	};

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) =>
	{
		event.preventDefault();
		await authService.login(password);
		window.location.href = "/mods";
	};

	return (
		<div className={styles.view}>
			<section className={styles.leftPanel}>
				<div className={styles.background} aria-hidden="true">
					<DottedBg2 bgColor="var(--color-background)" colors={["var(--color-background-bright)"]} speed={1} frequency={2} />
				</div>
				<img src="logo.svg" alt="" />
			</section>
			<section className={styles.rightPanel}>
				<div className={styles.form}>
					<div className={styles.header}>
						<p>Log in to</p>
						<h1>Server control panel</h1>
					</div>
					<form onSubmit={handleSubmit} id={styles.loginForm}>
						<PasswordInput onChange={handleChange} />
						<Button type="submit" label="Sign in" />
					</form>
					<div className={styles.versionNumber}>Version: {import.meta.env.VITE_APP_VERSION}</div>
				</div>
			</section>
		</div>
	);
};

export default LoginView;